"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.setAjaxConfig = void 0;
var axios_1 = __importDefault(require("axios"));
var isClient_1 = __importDefault(require("./isClient"));
var defaultAjaxConfig = {
    timeout: 1000 * 10,
};
function setAjaxConfig(config) {
    defaultAjaxConfig = __assign(__assign({}, defaultAjaxConfig), config);
}
exports.setAjaxConfig = setAjaxConfig;
var getUserIp = function (req) { return (req.headers['x-forwarded-for']
    || req.connection.remoteAddress
    || (req.socket && req.socket.remoteAddress)
    || (req.connection.socket && req.connection.socket.remoteAddress)); };
function request(requrl, options, ctx) {
    var url = requrl;
    var option = __assign(__assign({ headers: {} }, defaultAjaxConfig), options);
    var host;
    var protocol = '';
    if (isClient_1.default()) {
        host = window.location.host;
    }
    else {
        if (!ctx) {
            throw new Error('发生服务端请求，但未传context参数');
        }
        protocol = 'http:';
        host = ctx.internalHost || ctx.req.headers.host;
        option.headers['x-forwarded-for'] = getUserIp(ctx.req);
        option.headers = __assign(__assign(__assign({}, option.headers), ctx.req.headers), { host: host });
    }
    if (option.headers['content-length'] || option.headers['Content-Length']) {
        option.method = 'post';
        delete option.headers['content-length'];
        delete option.headers['Content-Length'];
    }
    if (!/^(http(s)?:)?\/\//.test(url)) {
        url = url.replace(/^(\.)?\//, '');
        url = protocol + "//" + host + "/" + url;
    }
    return axios_1.default(url, option);
}
exports.request = request;
//# sourceMappingURL=request.js.map